
import Numpad from '@/libs/common/components/Numpad.vue';
import { Component, Ref, VModel, Watch, Prop } from 'vue-property-decorator';
import Page from '@/Page.vue';
import KeyInput from '@/libs/common/components/KeyInput.vue';
import { authStore } from '@/libs/auth/+store/store';
import { AuthAction, AuthGetter } from '@/libs/auth/models/auth-state';
import { TenantModel, TenantUserModel } from '@/libs/Api';
import { SignInModel } from '@/libs/auth/models/auth-models';
import { EventTypeEnum } from '@/libs/core/models/event-type-enum';
import { AuthenticationType } from '@/libs/auth/models/auth-type';
import { applicationUserStore } from '@/libs/user-settings/+state/store';
import { CrudAction, CrudReponse } from '@/libs/core/+state/models/crud-action';
import { tenantsStore } from '@/libs/tenants/+state/store';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';

@Component({
    components: { KeyInput, Numpad },
})
export default class DeactivateQuickLoginDialog extends Page {
    @VModel() dialog!: boolean;
    @Prop() locked!: boolean;
    @Prop() closeable!: boolean;
    protected email = '';
    protected password = '';
    protected mfaCode = '';
    protected error: string | null = null;
    protected valid = true;
    protected sending = false;
    protected requiredMfa = false;
    basicRules = [(v: any) => !!v || this.$i18n.t('common.thisFileIsRequired')];

    @Ref() form!: any;

    @Watch('dialog')
    dialogChanged(v: boolean, p: boolean) {
        if (v && v != p) {
            const tenantUser: TenantUserModel = authStore.useGetter(AuthGetter.GetTenantUser) as TenantUserModel;
            this.email = tenantUser.user?.email ?? '';
            this.password = '';
            this.mfaCode = '';
            this.error = '';
            this.valid = true;
            this.sending = false;
            this.requiredMfa = false;
        }
    }

    protected onCloseClick(skipCloseEvent = false) {
        this.$emit('input', false);
        if (!skipCloseEvent) {
            this.$emit('close');
        }
    }

    protected onDeactivateClick() {
        window.localStorage.QuickLoginLocked = null;
        window.localStorage.TabletMode = null;
        window.localStorage.SharedMode = null;
        window.localStorage.ActiveWorkplace = null;
        window.localStorage.ActiveStation = null;
        authStore.dispatch(AuthAction.SetSharedMode, false);
        this.$emit('deactivated');
        this.$emit('input', false);
    }

    protected submit() {
        if (this.form.validate()) {
            const payload = new SignInModel();
            payload.email = this.email;
            payload.password = this.password;
            payload.mfaCode = this.mfaCode;
            this.sending = true;
            this.error = null;
            authStore.dispatch(AuthAction.SetAuthenticationType, AuthenticationType.Standard);
            authStore.dispatch(AuthAction.SignIn, payload);
            window.localStorage.ActivePanelDashboard = null;
            const self = this;
            const createdSubscriber = this.$store.subscribe((mutation, _state) => {
                if (mutation.type === authStore.getActionName(AuthAction.SignInResponse)) {
                    createdSubscriber();
                    self.sending = false;
                    if (typeof mutation.payload.error != undefined && mutation.payload.error == 'invalid_grant') {
                        self.error = this.$t('authentification.errors.signInFailed') as string;
                    } else if (typeof mutation.payload.error != undefined && mutation.payload.error == 'requires_mfa') {
                        self.requiredMfa = true;
                    } else if (typeof mutation.payload.error != undefined && mutation.payload.error == 'bad_mfa') {
                        self.error = this.$i18n.t('mfa.singInCommandError').toString();
                    } else {
                        authStore.dispatch(AuthAction.SetIsLocked, false);
                        this.onDeactivateClick();
                        this.onCloseClick(true);
                        self.goToTenantOrDefault();
                        (window as any).Journaly.publish(EventTypeEnum.SignedIn);
                    }
                }
            });
        }
    }

    signout() {
        this.$emit('signout');
    }

    private goToTenantOrDefault() {
        applicationUserStore.dispatch(CrudAction.Get, {});
        this.subscribe(applicationUserStore, CrudReponse.Get).then((e: any) => {
            tenantsStore.dispatch(CrudAction.GetAll, createCrudQueryPayload());
            this.subscribe(tenantsStore, CrudReponse.GetAll)
                .then((e: TenantModel[]) => {
                    if (window.localStorage.CurrentTenant && e.any((x) => x.id == window.localStorage.CurrentTenant)) {
                        authStore.dispatch(AuthAction.SetTenant, window.localStorage.CurrentTenant);
                        this.$router.push({ name: 'Home', params: { tenantId: window.localStorage.CurrentTenant } });
                    } else if (e.length > 0) {
                        authStore.dispatch(AuthAction.SetTenant, e[0].id!);
                        this.$router.push({ name: 'Home', params: { tenantId: e[0].id! } });
                    } else {
                        this.$router.push({ name: 'UserSettings' });
                    }
                })
                .catch(() => {
                    this.$router.push({ name: 'UserSettings' });
                });
        });
    }
}
